
export const Environment ={
   /*BENESHTY*/
/*      baseURL:'https://mehraelapi.geniussystemapi.com',
 */      baseURL:'https://beneshtyapi.geniussystemapi.com',  
         project:'GBCSDashboard'
 }

export default Environment